import {
    convertToRegionType,
    isKnownRegionType,
    RegionType
} from "./regionType";

export type Subscription = {
    readonly id: number;
    readonly region: RegionType;
    readonly unlimited: boolean;
    readonly numBuses: number;
    readonly numUnlockedBuses: number;
};

/**
 * The team's subscription for a region, if they have one. A team has at most one
 * subscription per region, so the first match is the only match.
 */
export const maybeGetSubscriptionForRegion = (
    subscriptions: ReadonlyArray<Subscription>,
    region: RegionType
): Subscription | undefined => {
    return subscriptions.find((subscription) => subscription.region === region);
};

/**
 * How many more buses a bus-limited subscription can unlock. Meaningless for an
 * unlimited subscription, whose bus count is not a limit.
 */
export const getBusesRemainingOnLimitedSubscription = (
    subscription: Subscription
): number => {
    return Math.max(subscription.numBuses - subscription.numUnlockedBuses, 0);
};

type HasuraCountAggregate = {
    readonly count: number;
};

type HasuraUnlockedBusesAggregate = {
    readonly aggregate?: HasuraCountAggregate | null;
};

export type HasuraSubscription = {
    readonly id: number;
    readonly region: string;
    readonly unlimited: boolean;
    readonly num_buses: number;
    readonly end_date: string;
    readonly unlocked_buses_aggregate: HasuraUnlockedBusesAggregate;
};

export const hasuraSubscriptionsToNiraSubscriptions = (
    hasuraSubscriptions: HasuraSubscription[]
): ReadonlyArray<Subscription> => {
    return hasuraSubscriptions
        .filter((hasuraSubscription) =>
            isKnownRegionType(hasuraSubscription.region)
        )
        .map(hasuraSubscriptionToNiraSubscription);
};

const hasuraSubscriptionToNiraSubscription = (
    hasuraSubscription: HasuraSubscription
): Subscription => {
    return {
        id: hasuraSubscription.id,
        region: convertToRegionType(hasuraSubscription.region),
        unlimited: hasuraSubscription.unlimited,
        numBuses: hasuraSubscription.num_buses,
        numUnlockedBuses:
            hasuraSubscription.unlocked_buses_aggregate.aggregate?.count || 0
    };
};
